import { Link, animateScroll as scroll } from 'react-scroll'

function Footer() {
  return (
    <footer>
      <div className="container">
        <div className="row" style={{alignItems: 'flex-start'}}>
          <div className="col-md-3">
            <img src={process.env.PUBLIC_URL + "/img/tss.png"} alt="TSS Logo" style={{maxWidth: '120px', marginBottom: '1rem'}} />
          </div>
          <div className="col-md-3">
            <p className="footer-title">Important Link</p>
            <ul>
              <li>
                <Link spy={true} smooth={true} duration={1000} to="headerbg" offset={-100}>Home</Link>
              </li>
              <li>
                <Link to="services" spy={true} smooth={true} duration={1000} offset={0}>Services</Link>
              </li>
              <li>
                <Link to="about-scroll" spy={true} smooth={true} duration={1000} offset={-100}>About</Link>
              </li>
              <li>
                <Link to="experience" spy={true} smooth={true} duration={1000} offset={-50}>Experience</Link>
              </li>
              <li>
                <Link to="contact" spy={true} smooth={true} duration={1000} offset={-92}>Contact</Link>
              </li>
            </ul>
          </div>
          <div className="col-md-3">
            <p className="footer-title">Contact</p>
            <ul>
              <li>
                <a href="mailto:ocean@solusion7.com">ocean@solusion7.com</a>
              </li>
              <li>
                <a href="mailto:EMEA@solusion7.com">EMEA@solusion7.com</a>
              </li>
              <li>
                <a href="tel:+628126000766">+62 812 6000 766 (APAC)</a>
              </li>
            </ul>
          </div>
          <div className="col-md-3">
            <p className="footer-title">Social Media</p>
            <ul>
              <li>
                <a target="_blank" rel="noreferrer" href="https://www.linkedin.com/company/tsscable">Linkedin</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <button onClick={() => scroll.scrollToTop(2500)} className="gotop">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
          <path d="M18 15l-6-6-6 6"/>
        </svg>
      </button>

    </footer>
  );
}
export default Footer;
